module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Trasadingen-51dcaa01d2049f154f602148bd5fcf7f.png";